import React, { Fragment } from 'react';
import classNames from 'classnames';
import { PT_STARS, DF_STARS } from './proptypes';
import starIconsSources from './utils/sources-stars';
import getStars from './utils/get-stars';

const MAX_STARS = 5;

const renderRating = (stars, namespace) =>
  stars.map((star, index) => {
    const startKay = `star-item-${index}`;
    const { [star]: StarIcon } = starIconsSources;
    const isEmpty = star === 'EMPTY';
    const starStyleClasses = `${namespace}__star${isEmpty ? ` ${namespace}__star-empty` : ''}`;

    return (
      StarIcon && (
        <Fragment key={startKay}>
          <StarIcon className={classNames(starStyleClasses)} />
        </Fragment>
      )
    );
  });

const Stars = ({ className, value, aria_label }) => {
  const { STARS } = getStars(value, MAX_STARS);
  const ratings = renderRating(STARS, className);

  return (
    <div className={className}>
      {ratings}
      <p className="andes-visually-hidden">{aria_label}</p>
    </div>
  );
};

Stars.propTypes = {
  ...PT_STARS,
};

Stars.defaultProps = {
  ...DF_STARS,
};

export default React.memo(Stars);
